<template>
  <div class="flex flex-row justify-end mr-5 gap-7" v-if="step.automation_type === 'TASK'">
    <div v-for="metric in taskMetrics"
         :key="metric.label"
         class="flex flex-col gap-1">
      <span class="text-sm secondary_color">{{ metric.label }}</span>
      <span class="text-lg font-semibold">{{ metric.value }}</span>
    </div>
  </div>

  <div class="flex flex-row justify-end mr-5 gap-7" v-else-if="step.step_type === 'EMAIL'">
    <div v-for="metric in metrics"
         :key="metric.label"
         class="flex flex-col gap-1">
      <span class="text-sm secondary_color">{{ metric.label }}</span>
      <span class="text-lg font-semibold">{{ metric.value }}</span>
    </div>
  </div>

  <div class="flex flex-row justify-end mr-5 gap-7" v-else>
    <div class="md:col-span-2"></div>
    <div v-for="metric in linkedinMetrics"
         :key="metric.label"
         class="flex flex-col gap-1">
      <span class="text-sm secondary_color">{{ metric.label }}</span>
      <span class="text-lg font-semibold">{{ metric.value }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  metrics: {
    type: Object
  },
  step: {
    type: Object
  }
})

const formatPercentage = (value) => {
  return value ? `${value.toFixed(1)}%` : '0%'
}

const metrics = computed(() => [
  {
    label: 'Total Sent',
    value: props.metrics.total_sent
  },
  {
    label: 'Total Open',
    value: props.metrics.total_opens
  },
  {
    label: 'Clicks',
    value: props.metrics.total_clicks
  },
  {
    label: 'Replies',
    value: props.metrics.total_replies
  }
])

const linkedinMetrics = computed(() => [
  {
    label: 'Total Sent',
    value: props.metrics.total_sent
  }
])

const taskMetrics = computed(() => [
  {
    label: 'Total Complete',
    value: props.metrics.total_sent
  }
])
</script>